import { Box, Container, Stack, Typography } from '@mui/material';
import { SettingsNotifications } from '../sections/settings/SettingsNotifications';
import { SettingsPassword } from '../sections/settings/SettingsPassword';
import { DashboardLayout } from 'layouts/dashboard/DashboardLayout';

const Settings = () => (
  <DashboardLayout>
    <Box
      component='main'
      sx={{
        flexGrow: 1,
        py: 8,
      }}
    >
      <Container maxWidth='lg'>
        <Stack spacing={3}>
          <Typography variant='h4'>Settings</Typography>
          <SettingsNotifications />
          <SettingsPassword />
        </Stack>
      </Container>
    </Box>
  </DashboardLayout>
);

export default Settings;
